import React, { useEffect, useState } from 'react';
import { ReactComponent as IconClearFilter } from 'icons/icon-clear-filter.svg';
import RecentEntities from '../RecentEntities/RecentEntities';
import {
  ButtonWrapper,
  RecentEntitiesWrapper,
  ClearRecent,
  RecentButtonWrapper,
} from './SearchDropdown.styles';
import { IRecentItem } from './SearchDropdown';
import { IEntityInfo } from 'pages/Search';
import { IEntity } from '../ResultsSection/ResultsList/ResultsList';

interface IRecentEntitiesSectionProps {
  isLoadingRecent: boolean;
  recentList: IRecentItem[];
  onAddToListClick: (entityInfo: IEntityInfo) => void;
  addToRecentItems: (entityInfo: IEntity) => void;
  clearRecentItems: () => void;
  recentMetadata: any;
  searchValue: string;
  activeEntityType: string;
  isSmallScreen: boolean;
}

const RecentEntitiesSection: React.FC<IRecentEntitiesSectionProps> = (
  props
) => {
  const {
    isLoadingRecent,
    onAddToListClick,
    addToRecentItems,
    recentList,
    recentMetadata,
    searchValue,
    clearRecentItems,
    activeEntityType,
    isSmallScreen,
  } = props;

  const [showAllRecent, setShowAllRecent] = useState<boolean>(false);
  const [recentViewData, setRecentViewData] = useState<IEntity[]>();

  const hideRecentSection =
    !isLoadingRecent &&
    searchValue.length &&
    activeEntityType === 'all' &&
    (!recentViewData || !recentViewData?.length);
  const hideShowAllButton =
    (recentViewData && recentViewData.length < 5) || showAllRecent;
  const hideClearButton = !recentViewData || !recentViewData.length;

  useEffect(() => {
    if (activeEntityType === 'all') setShowAllRecent(false);
  }, [activeEntityType]);

  useEffect(() => {
    let result: IEntity[] =
      recentMetadata && recentList && recentList.length
        ? recentMetadata
            .map((rd: any) => ({
              ...rd,
              lastVisit: recentList.find(
                (rl: IRecentItem) => rl.entityId === rd.id
              )?.lastVisit,
            }))
            .sort(
              (a: IEntity, b: IEntity) =>
                Date.parse(b.lastVisit) - Date.parse(a.lastVisit)
            )
        : [];
    if (recentMetadata) {
      if (searchValue) {
        result = result.filter(
          (data: any) =>
            data.displayName.toLowerCase().indexOf(searchValue.toLowerCase()) >
              -1 ||
            data.primaryArtist?.displayName
              .toLowerCase()
              .indexOf(searchValue.toLowerCase()) > -1
        );
      }
      if (!showAllRecent) result = result.slice(0, 5);
    }
    setRecentViewData(result);
  }, [recentMetadata, recentList, searchValue, showAllRecent]);

  return (
    <>
      {hideRecentSection ? null : (
        <RecentEntitiesWrapper>
          <RecentEntities
            data={isLoadingRecent ? undefined : recentViewData}
            loading={isLoadingRecent}
            onAddToListClick={onAddToListClick}
            onOpenEntity={addToRecentItems}
          />
          <RecentButtonWrapper
            hiddenShowAll={hideShowAllButton}
            hiddenClear={hideClearButton}
          >
            <ButtonWrapper>
              <button onClick={(): void => setShowAllRecent(true)}>
                Show all recent results
              </button>
            </ButtonWrapper>
            <ClearRecent>
              <button
                onClick={(): void => {
                  clearRecentItems();
                  setRecentViewData([]);
                }}
              >
                {!isSmallScreen && <IconClearFilter />}
                Clear recents
              </button>
            </ClearRecent>
          </RecentButtonWrapper>
        </RecentEntitiesWrapper>
      )}
    </>
  );
};

export default RecentEntitiesSection;
